import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
// import { environment } from '../../environments/environment';
import { saveAs } from 'file-saver';
import { createFeatureSelector, Store } from '@ngrx/store';
import { ApplicationState } from '../state-management/application/application.state';
import { takeUntil } from 'rxjs/operators';

// const printServiceUrl = environment.webApiUrl + 'api/print';

const httpOptions = {
  headers: new HttpHeaders({
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache'
  }),
  responseType: 'blob' as 'json'
};

export interface AppState {
  applicationReducer: ApplicationState;
}

export const getAppState = createFeatureSelector<ApplicationState>('applicationReducer');

@Injectable()
export class PrintService implements OnDestroy {
  headers: any;
  error: any;
  httpOptions = httpOptions;
  appSettings: any;
  private ngUnsubscribe: Subject<void> = new Subject();

  constructor(private httpClient: HttpClient,
    private store: Store<AppState>) {
    this.store.select(getAppState).pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe((state: any) => {
      this.appSettings = state.appSettings;
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  exportPdf(fileName: string, webMapExport: WebMapExport): void {
    const printServiceUrl = this.appSettings['environment.webApiUrl'] + 'api/print';
    this.httpClient.post<any>(printServiceUrl + '/export/pdf', webMapExport, this.httpOptions)
      .subscribe((data) => { saveAs(data, fileName); });
  }

  createPdf(file: Blob): void {
    // console.log("GOT HERE3");
    saveAs(file, 'map.png');
    /*
    this.httpClient.post<any>('url', file, {
      // NOTE: Because we are posting a Blob (File is a specialized Blob
      // object) as the POST body, we have to include the Content-Type
      // header. If we don't, the server will try to parse the body as
      // plain text.
      headers: {
        'Content-Type': file.type
      },
      params: {
        clientFilename: 'map.pdf',
        mimeType: file.type
      }
    });
    */
  }
}

// https://enterprise.arcgis.com/en/server/latest/create-web-apps/windows/exportwebmap-specification.htm
export class WebMapExport {
  mapOptions: WebMapMapOption;
  operationalLayers: WebMapOperationalLayer[];
  baseMap?: WebMapBaseMap;
  exportOptions: WebMapExportOptions;
  layoutOptions?: WebMapLayoutOptions;
}

export class WebMapMapOption {
  showAttribution: boolean;
  extent: WebMapExtent;
  spatialReference: WebMapSpatialReference;
  scale?: number;
}

export class WebMapExtent {
  xmin: number;
  ymin: number;
  xmax: number;
  ymax: number;
  spatialReference: WebMapSpatialReference;
}

export class WebMapSpatialReference {
  wkid: number;
}

export class WebMapBaseMap {
  title: string;
  baseMapLayers: WebmapBaseMapLayer[];
}

export class WebmapBaseMapLayer {
  url: string;
  opacity?: number;
}

export class WebMapExportOptions {
  dpi?: number;
  outputSize?: [number, number];
}

export class WebMapOperationalLayer {
  /*
    "id" : "<webmapOperationalLayerId>",
    "url" : "<url1>",
    "token" : "<tokenString1>",
    "title" : "<title1>",
    "opacity" : <opacity1>,
    "visibility" : <true | false>,
    "minScale" : <minScale1>,
    "maxScale" : <maxScale1>
  */
  /*
  "operationalLayers" : [
   {
     "url" : "https://servicesbeta.esri.com/ArcGIS/rest/
             services/HomelandSecurity/operations/
             MapServer",
     "title" : "Homeland security operations",
     "opacity" : 0.8,
     "visibleLayers" : [
     0,
     1
     ]
   }
   ]*/
  url: string;
  title: string;
  opacity: number;
  visibleLayers: number[];
}

export class WebMapLayoutOptions {
  /*
  "layoutOptions" : {
  "titleText" : "<title>",
  "authorText" : "<authorName>",
  "copyrightText" : "<copyright>",
  "scaleBarOptions" :  {
    "metricUnit" : "<esriMeters | esriKilometers>" ,
    "metricLabel" : "<metricUnitLabel>",
    "nonMetricUnit" : "<esriFeet | esriYards | esriMiles |
                      esriNauticalMiles>" ,
    "nonMetricLabel" : "<nonMetricUnitLabel>"
  },
  "customTextElements" : [
    {"<textElementName1>" : "<value1>"},
    {"<textElementName2>" : "<value2>"}
  ],
  "legendOptions" : {
    "operationalLayers" : [
    {
      "id" : "<webmapOperationalLayerId>",
      "sublayerIds" : [  //array of string or number
        <mapServerSublayerId1>,
        <mapServerSublayerId2>
      ]
    }
    ]
  }
  }
  */
}
